import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonComponent } from '@lx/shared/ui/button';
import { AsyncPipe, LowerCasePipe, NgClass, NgIf } from '@angular/common';
import { TreeModule } from 'primeng/tree';
import { Company } from '../../models/company.model';
import { DestinationFilter } from '../../models';
import { SharedDataStore } from '../../store';
import { Observable } from 'rxjs';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-destination-filter',
  imports: [ButtonComponent, NgClass, TreeModule, NgIf, LowerCasePipe, AsyncPipe],
  templateUrl: './destination-filter.component.html',
  styleUrls: ['./destination-filter.component.scss'],
})
export class DestinationFilterComponent implements OnInit, OnChanges {
  @Input() priceListFilters: DestinationFilter[] | undefined = [];
  @Output() filtersChanged: EventEmitter<DestinationFilter | DestinationFilter[]> = new EventEmitter();

  company$: Observable<Company> | undefined;

  filters: DestinationFilter[] = [];
  selectedFilters: DestinationFilter | DestinationFilter[] = [];

  private readonly sharedDataStore = inject(SharedDataStore);

  ngOnInit(): void {
    this.company$ = this.sharedDataStore.company$;
  }

  ngOnChanges({ priceListFilters }: SimpleChanges): void {
    if (priceListFilters.currentValue) {
      this.filters = this.priceListFilters || [];
    }
  }

  clearFilter() {
    this.selectedFilters = [];
    this.filters = this.priceListFilters.map((node) => ({ ...node, partialSelected: false }));
    this.emitFiltersChanged();
  }

  emitFiltersChanged() {
    this.filtersChanged.emit(this.selectedFilters);
  }
}
